
 (function changeLocalText() {
    $.ajax({
        url: "https://extreme-ip-lookup.com/json/?key=2OwMCANHBc6WEBwgSPDN",
        async: false,
        timeout: 30000
    }).then(function success(response) {

        let translations = {
          en: {
            Denmark: "DK delivery: 1 – 3 days",
            "United Kingdom": "UK delivery: 2 – 5 days",
            Europe: "EU delivery: 4 – 10 days",
          },
          da: {
            Denmark: "DK levering: 1 – 3 dage",
            "United Kingdom": "UK levering: 2 – 5 dage",
            Europe: "EU levering: 4 – 10 dage",
          },
          de: {
            Denmark: "DK Lieferung: 1 – 3 Tage",
            "United Kingdom": "UK Lieferung: 2 – 5 Tage",
            Europe: "EU Lieferung: 4 – 10 Tage",
          },
          fr: {
            Denmark: "Livraison DK : 1 – 3 jours",
            "United Kingdom": "Livraison au Royaume-Uni : 2 – 5 jours",
            Europe: "Livraison UE : 4 – 10 jours",
          },
        };
      
        let lang = document.getElementsByTagName("html")[0].getAttribute("lang");
        let translation = translations[lang] || translations["en"]; 
        
        if (response.country === "Denmark") {
          $(".psst-shipping-text").text(translation["Denmark"]);
        } else if (response.country === "United Kingdom") {
          $(".psst-shipping-text").text(translation["United Kingdom"]);
        } else if (response.continent === "Europe") {
          $(".psst-shipping-text").text(translation["Europe"]);
                }
        else {
            $(".psst-shipping-text").text("International delivery: 1 – 2 weeks");
            $(".free-ship").remove();
            $(".modu-topBar__delivery").text("International delivery: 1 – 2 weeks");
            $(".data-gt-block").text("International delivery: 1 – 2 weeks");   
        }
    });
})();

// Initialize product slider when a variant is selected
$(".js-variant-dot").click( function () {
    const variant = this.getAttribute('data-variant');
    const slider = $(`.modu-productSlideshow[data-variant="${variant}"]`);
    initModuSlider(slider);
})

const initModuSlider = (slider) => {
    if(slider.hasClass('slick-initialized') == false){
        setTimeout(() => {
            slider.slick({
                dots: true,
                arrows: true,
                slidesToShow: 1,
                infinite: true,
                vertical: true,
                verticalSwiping: true,
                rows: 0,
                responsive: [
                    {
                        breakpoint: 800,
                        settings: {
                            vertical: false,
                            verticalSwiping: false,
                            variableHeight: true,
                            arrows: true,
                            infinite: true,
                        }
                    }
                ]
            });

            // slider.on('beforeChange', (function() { $(window).scrollTop(0); }));
        }, 100)
    }
}


// Adds click support to desktop sliders (product pages)
document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.modu-productSlideshow') && window.matchMedia("(min-width: 800px)").matches) {
    const elem = $('.modu-productSlideshow');

    elem.on('click', function (e) {
      const sliderHeight = $(this).outerHeight();
      const clickPosition = e.pageY - $(this).offset().top;
      const isTopHalf = clickPosition < sliderHeight / 3;

      if (isTopHalf) {
        // Clicked on top half, move to previous slide
        $(this).slick('slickPrev');
      } else {
        // Clicked on bottom half, move to next slide
        $(this).slick('slickNext');
      }
    });

    elem.on('mousemove', function (e) {
      const sliderHeight = $(this).outerHeight();
      const cursorPosition = e.pageY - $(this).offset().top;
      const isTopHalf = cursorPosition < sliderHeight / 3;

      if (isTopHalf && $(this).css('cursor') !== 'url("up-arrow.png"), auto') {
        // Hovering on top half, arrow should point up
        $(this).css('cursor', 'url("https://cdn.shopify.com/s/files/1/0016/1264/4407/t/91/assets/arrow-up-32.png?v=1679405614") 19 1, n-resize');
      } else if (!isTopHalf && $(this).css('cursor') !== 'url("down-arrow.png"), auto') {
        // Hovering on bottom half, arrow should point down
        $(this).css('cursor', 'url("https://cdn.shopify.com/s/files/1/0016/1264/4407/t/91/assets/arrow-down-32.png?v=1679405602") 19 1, s-resize');
      }
    });

    elem.on('mouseleave', function () {
      $(this).find('.slider-arrow').remove();
      $(this).css('cursor', 'auto');
    });
  }
});













